import script from "./widgetChartPie.vue?vue&type=script&lang=js"
export * from "./widgetChartPie.vue?vue&type=script&lang=js"

import "./widgetChartPie.vue?vue&type=style&index=0&id=d53a30bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d53a30bc"],['__file',"src/components/widgets/widgetChartPie.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d53a30bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d53a30bc', __exports__)) {
    api.reload('d53a30bc', __exports__)
  }
  
}


export default __exports__